<template>
  <div>
    <b-card no-body>
      <b-card-header :class="{ 'sticky-header': showHeader }">
        <b-row align-v="center">
          <b-col cols="auto" class="mr-auto">
            <h5 class="mb-0">{{title}}</h5>
          </b-col>
          <b-col cols="auto">
            <b-button size="sm" variant="info" class="mr-2" @click="openModalCopying()" :disabled="isBusy">
              <font-awesome-icon icon="copy" class="mr-1"/>
              Копировать
            </b-button>
            <b-button id="table-settings" size="sm" variant="warning" :disabled="isBusy" v-b-toggle.sidebar-fields-location-vacancies>
              <font-awesome-icon icon="cog"/>
            </b-button>
            <b-tooltip target="table-settings" triggers="hover" variant="warning" noninteractive>
              Строки
            </b-tooltip>
            <b-button v-if="!showDetails" size="sm" variant="success" @click.stop="onAdd()" :disabled="isBusy || isDisabled">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Добавить
            </b-button>
            <b-button v-if="showDetails" variant="link" class="text-secondary ml-3 p-0" @click="$emit('close')">
              <font-awesome-icon icon="times" size="lg"/>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="items.length > 0">
        <b-table
          id="location-vacancies"
          ref="location_vacancies"
          class="mb-0 no-borders-table"
          thead-class="d-none"
          bordered
          small
          responsive
          :items="renderedColumns"
          :fields="setupColumns"
        >
          <!-- Левая колонка строк заголовков -->
          <template #cell(row_title)="col">
            <!-- Заголовки групп данных -->
            <div v-if="col.item.type === 'header'" class="row-header">
              <span class="mr-auto"> {{ col.value }} </span>
            </div>
            <!-- Строка заголовок -->
            <div v-else class="py-1 pl-1 d-flex align-items-center">
              <span class="font-weight-bold mr-auto">{{ col.value }}</span>
              <span v-if="allFieldsRequired" class="font-weight-bold text-danger">*</span>
              <b-form-checkbox
                v-if="col.item.isJoint && items.length > 1"
                v-model="jointFields"
                :value="col.item.key"
                switch
                size="sm"
                class="ml-2 warning-checkbox"
                @change="onToggleJoint(col.item.key)"
              />
            </div>
          </template>

          <!-- Правые колонки данных -->
          <template #cell()="col">
            <!-- joint fields -->
            <div v-if="isFieldJoint(col.item.key)" class="px-1">

              <div v-if="col.item.key === 'citizenships'">
                <citizenships-multi-select
                  :value="items[0].citizenships"
                  :catalog-items="citizenshipsCatalog"
                  @catalog-created="getCatalogs"
                  @input="updateAllItems('citizenships', $event)"
                  :is-disabled="isDisabled"
                />
              </div>

              <div v-else-if="col.item.key === 'employment'" class="d-flex align-items-center">
                <b-dropdown
                  :text="getMultiSelectText(items[0].employment_types, employmentTypesOptions)"
                  :disabled="isDisabled"
                  variant="outline-primary"
                  size="sm"
                  class="w-40 mr-1 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      :checked="items[0].employment_types"
                      @change="updateAllItems('employment_types', $event)"
                      :options="employmentTypesOptions"
                      stacked
                      class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
                <b-form-textarea
                  class="w-60 text-small"
                  :value="items[0].employment"
                  @input="updateAllItems('employment', $event)"
                  :disabled="isDisabled" rows="2" :placeholder="col.item.placeholder"
                />
              </div>

              <div v-else-if="col.item.key === 'employment_categories'">
                <employment-categories-multi-select
                  :value="items[0].employment_categories"
                  :catalog-items="employmentCategoriesCatalog"
                  @catalog-created="getCatalogs"
                  @input="updateAllItems('employment_categories', $event)"
                  :is-disabled="isDisabled"
                />
              </div>

              <div v-else-if="col.item.key === 'certificates'" class="d-flex align-items-center">
                <driver-license-categories-multi-select
                  class="w-25 mr-1"
                  :value="items[0].driver_license_categories"
                  :catalog-items="driverLicenseCategoriesCatalog"
                  @catalog-created="getCatalogs"
                  @input="updateAllItems('driver_license_categories', $event)"
                  :is-disabled="isDisabled"
                />
                <b-form-textarea
                  class="w-75 text-small"
                  :value="items[0].certificates"
                  @input="updateAllItems('certificates', $event)"
                  :disabled="isDisabled" rows="2" :placeholder="col.item.placeholder"
                />
              </div>

              <div v-else-if="col.item.key === 'shift_hours'" class="d-flex align-items-center px-1">
                <b-form-input
                  type="time"
                  :value="getShiftTime(items[0].shift_hours, 0)"
                  @input="updateShiftTimeJoint(0, $event)"
                  :disabled="isDisabled"
                  size="sm"
                  class="mr-1 w-50"
                />
                <b-form-input
                  type="time"
                  :value="getShiftTime(items[0].shift_hours, 1)"
                  @input="updateShiftTimeJoint(1, $event)"
                  :disabled="isDisabled"
                  size="sm"
                  class="mr-1 w-50"
                />
              </div>

              <div v-else-if="col.item.key === 'schedule'" class="d-flex align-items-center">
                <b-form-textarea
                  :value="items[0].schedule"
                  @input="updateAllItems('schedule', $event)"
                  :disabled="isDisabled"
                  rows="1" max-rows="4"
                  class="mr-1 text-small"
                  placeholder="График"
                />
                <b-dropdown
                  :text="getMultiSelectText(items[0].schedule_time_of_day, shiftOptions)"
                  :disabled="isDisabled"
                  variant="outline-primary"
                  size="sm"
                  class="w-25 mr-1 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      :checked="items[0].schedule_time_of_day"
                      @change="updateAllItems('schedule_time_of_day', $event)"
                      :options="shiftOptions"
                      stacked
                      class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
                <b-form-textarea
                  :value="items[0].night_coefficient"
                  @input="updateAllItems('night_coefficient', $event)"
                  :disabled="isDisabled"
                  size="sm"
                  rows="2"
                  max-rows="6"
                  class="text-small"
                  placeholder="Ночной коэф."
                />
              </div>

              <b-form-textarea
                v-else-if="col.item.type === 'input'"
                :disabled="isDisabled"
                rows="2"
                max-rows="6"
                :value="items[0][col.item.key]"
                @input="updateAllItems(col.item.key, $event)"
                class="text-small"
                :placeholder="col.item.placeholder || 'Значение для всех вакансий'"
              />

              <b-form-input
                v-else-if="col.item.type === 'number'"
                :disabled="isDisabled"
                type="number"
                :value="items[0][col.item.key]"
                @input="updateAllItems(col.item.key, $event)"
                class="text-small"
                :placeholder="col.item.placeholder || 'Введите число'"
                @keydown="onlyNumbers"
              />

              <div v-else-if="col.item.type === 'range'" class="d-flex align-items-center px-5">
                <b-form-input
                  :disabled="isDisabled"
                  type="number"
                  :value="items[0].age_from"
                  @input="updateAllItems('age_from', $event)"
                  class="text-small mr-5"
                  placeholder="От"
                  @keydown="onlyNumbers"
                />
                <b-form-input
                  :disabled="isDisabled"
                  type="number"
                  :value="items[0].age_to"
                  @input="updateAllItems('age_to', $event)"
                  class="text-small"
                  placeholder="До"
                  @keydown="onlyNumbers"
                />
              </div>

              <div v-else-if="col.item.type === 'checkbox-input'" class="d-flex align-items-center px-3">
                <b-form-checkbox
                  :checked="items[0][col.item.key]"
                  @change="updateAllItems(col.item.key, $event)"
                  :disabled="isDisabled"
                  class="mr-2 mb-0"
                />
                <b-form-textarea
                  :value="items[0][col.item.commentKey]"
                  @input="updateAllItems(col.item.commentKey, $event)"
                  :disabled="isDisabled"
                  rows="2"
                  max-rows="6"
                  class="text-small"
                  :placeholder="col.item.placeholder || 'Добавьте комментарий'"
                />
              </div>

              <div v-else-if="col.item.type === 'multiselect'" class="d-flex align-items-center justify-content-center">
                <b-dropdown
                  :text="getMultiSelectText(items[0][col.item.key], getOptions(col.item.optionsKey))"
                  :disabled="isDisabled" variant="outline-primary" size="sm" class="w-75 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      :checked="items[0][col.item.key]"
                      @change="updateAllItems(col.item.key, $event)"
                      :options="getOptions(col.item.optionsKey)"
                      stacked
                      class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </div>

            <!-- separated fields -->

            <div v-else class="px-1 min-w-327">
              <div v-if="col.item.key === 'vacancy'">
                <b-button-group class="d-flex">
                <vacancy-select
                  class="flex-grow-1"
                  ref="vacancy_select"
                  :id="items[col.field.key].vacancy_id"
                  :is-disabled="isDisabled"
                  @onSelect="onSelectVacancy($event, col.field.key)"
                />
                  <b-button v-if="!showDetails" :disabled="isDisabled" variant="danger" size="sm" class="flex-grow-0" @click="onRemove(col.field.key)">
                    <font-awesome-icon icon="trash"/>
                  </b-button>
                </b-button-group>
              </div>

              <div v-else-if="col.item.key === 'citizenships'">
                <citizenships-multi-select
                  v-model="items[col.field.key].citizenships"
                  :catalog-items="citizenshipsCatalog"
                  @catalog-created="getCatalogs"
                  :is-disabled="isDisabled"
                />
              </div>

              <div v-else-if="col.item.key === 'employment_categories'">
                <employment-categories-multi-select
                  v-model="items[col.field.key].employment_categories"
                  :catalog-items="employmentCategoriesCatalog"
                  @catalog-created="getCatalogs"
                  :is-disabled="isDisabled"
                />
              </div>

              <div v-else-if="col.item.key === 'employment'" class="d-flex align-items-center">
                <b-dropdown
                  :text="getMultiSelectText(items[col.field.key].employment_types, employmentTypesOptions)"
                  :disabled="isDisabled"
                  variant="outline-primary"
                  size="sm"
                  class="w-40 mr-1 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      v-model="items[col.field.key].employment_types"
                      :options="employmentTypesOptions"
                      stacked class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
                <b-form-textarea
                  class="w-60 text-small"
                  v-model="items[col.field.key].employment"
                  :disabled="isDisabled"
                  rows="2"
                  :placeholder="col.item.placeholder"
                />
              </div>

              <div v-else-if="col.item.key === 'certificates'" class="d-flex align-items-center flex-wrap">
                <driver-license-categories-multi-select
                  style="flex: 1 1 50%;"
                  class="mr-1"
                  v-model="items[col.field.key].driver_license_categories"
                  :catalog-items="driverLicenseCategoriesCatalog"
                  @catalog-created="getCatalogs"
                  :is-disabled="isDisabled"
                />
                <b-form-textarea
                  style="flex: 1 1 40%;"
                  class="text-small"
                  v-model="items[col.field.key].certificates"
                  :disabled="isDisabled"
                  rows="2"
                  :placeholder="col.item.placeholder"
                />
              </div>

              <div v-else-if="col.item.key === 'shift_hours'" class="d-flex align-items-center justify-content-center w-100">
                <b-form-input
                  type="time"
                  :value="getShiftTime(items[col.field.key].shift_hours, 0)"
                  @input="updateShiftTimeSeparated(col.field.key, 0, $event)"
                  :disabled="isDisabled"
                  size="sm"
                  style="max-width: 85px;"
                  class="mr-1 text-center"
                />
                <b-form-input
                  type="time"
                  :value="getShiftTime(items[col.field.key].shift_hours, 1)"
                  @input="updateShiftTimeSeparated(col.field.key, 1, $event)"
                  :disabled="isDisabled"
                  size="sm"
                  class="text-center"
                  style="max-width: 85px;"
                />
              </div>

              <div v-else-if="col.item.key === 'schedule'" class="d-flex align-items-center justify-content-center">
                <b-form-textarea
                  v-model="items[col.field.key].schedule"
                  :disabled="isDisabled"
                  size="sm"
                  rows="2"
                  max-rows="6"
                  class="mr-1 text-small"
                  placeholder="Укажите график"
                />
                <b-dropdown
                  :text="getMultiSelectText(items[col.field.key].schedule_time_of_day, shiftOptions)"
                  :disabled="isDisabled"
                  variant="outline-primary"
                  size="sm"
                  class="w-33 mr-1 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      v-model="items[col.field.key].schedule_time_of_day"
                      :options="shiftOptions"
                      stacked
                      class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
                <b-form-textarea
                  v-model="items[col.field.key].night_coefficient"
                  :disabled="isDisabled"
                  size="sm"
                  rows="2"
                  max-rows="6"
                  class="text-small"
                  placeholder="Ночной коэф."
                />
              </div>

              <b-form-textarea
                v-else-if="col.item.type === 'input'"
                :disabled="isDisabled"
                size="sm"
                rows="2"
                max-rows="6"
                v-model="items[col.field.key][col.item.key]"
                :placeholder="col.item.placeholder"
              />

              <b-form-input
                v-else-if="col.item.type === 'number'"
                :disabled="isDisabled"
                min="0"
                type="number"
                size="sm"
                v-model.number="items[col.field.key][col.item.key]"
                :placeholder="col.item.placeholder"
                @keydown="onlyNumbers"
              />

              <div v-else-if="col.item.type === 'range'" class="d-flex justify-content-center">
                <b-form-input
                  :disabled="isDisabled"
                  type="number"
                  min="0"
                  size="sm"
                  v-model.number="items[col.field.key].age_from"
                  class="mr-1 w-25"
                  placeholder="От"
                  @keydown="onlyNumbers"
                />
                <b-form-input
                  :disabled="isDisabled"
                  type="number"
                  min="0"
                  size="sm"
                  class="w-25"
                  v-model.number="items[col.field.key].age_to"
                  placeholder="До"
                  @keydown="onlyNumbers"
                />
              </div>

              <div v-else-if="col.item.type === 'checkbox-input'" class="d-flex align-items-center px-3">
                <b-form-checkbox
                  v-model="items[col.field.key][col.item.key]"
                  :disabled="isDisabled"
                  class="mr-2 mb-0"
                />
                <b-form-textarea
                  v-model="items[col.field.key][col.item.commentKey]"
                  :disabled="isDisabled"
                  rows="2"
                  max-rows="6"
                  class="text-small"
                  :placeholder="col.item.placeholder || 'Комментарий'"
                />
              </div>

              <div v-else-if="col.item.type === 'multiselect'" class="d-flex align-items-center justify-content-center">
                <b-dropdown
                  :text="getMultiSelectText(items[col.field.key][col.item.key], getOptions(col.item.optionsKey))"
                  :disabled="isDisabled"
                  variant="outline-primary"
                  size="sm"
                  class="w-25 text-small"
                >
                  <b-dropdown-form>
                    <b-form-checkbox-group
                      v-model="items[col.field.key][col.item.key]"
                      :options="getOptions(col.item.optionsKey)"
                      stacked
                      class="text-small"
                    />
                  </b-dropdown-form>
                </b-dropdown>
              </div>
            </div>
          </template>
        </b-table>
      </div>
      <div v-else-if="isBusy" class="text-center text-success my-2">
        <b-spinner class="align-middle"/>
        <strong>Загрузка</strong>
      </div>
      <div v-else class="empty-placeholder">
        {{ $t('message.common.emptyTable') }}
      </div>
      <b-card-footer v-if="!showDetails" footer-bg-variant="light">
        <b-row align-h="between" align-v="center">
          <b-col cols="auto" class="mr-auto">
            Всего записей: <b>{{items.length}}</b>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal
      id="modal-vacancy-copying"
      ref="modal_vacancy_copying"
      title="Текст вакансий объекта"
      size="xl"
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      v-model="showModalCopying"
    >
      <b-card no-body v-if="items.length > 0">
        <b-tabs pills card vertical>
          <b-tab
            v-for="(item, index) in items"
            :key="index"
            :title="vacancyModalTabTitles[index]"
          >
            <b-row class="mb-2">
              <b-col cols="auto" class="ml-auto">
                <b-button size="sm" variant="outline-primary" @click="copyToClipboard(index)">
                  <font-awesome-icon icon="copy" class="mr-1"/>
                  Скопировать текст
                </b-button>
              </b-col>
            </b-row>
            <b-form-textarea
              :id="'vacancy-text-' + index"
              no-resize
              readonly
              rows="45"
              class="p-3 bg-light"
              :value="generateVacancyText(item)"
            />
          </b-tab>
        </b-tabs>
      </b-card>
      <div v-else class="text-center text-muted py-4">
        Нет добавленных вакансий.
      </div>
      <template #modal-footer="{cancel}">
        <b-button size="sm" variant="secondary" @click="closeModalCopying()">
          Назад
        </b-button>
      </template>
    </b-modal>

    <dynamic-tables
      storage-key="locationVacancies_columns"
      sidebar-fields="sidebar-fields-location-vacancies"
      :fields-model.sync="columns"
      fieldKey="vacancy"
    />

  </div>
</template>

<script>
import locationVacancies from "../../network/locationVacancies";
import catalogs from "../../network/catalogs";
  import helpers from "../../utilites/helpers";
  import DynamicTables from "../../utilites/commonUi/DynamicTables.vue";
    import VacancySelect from "../Catalogs/Vacancies/VacancySelect.vue";
    import CitizenshipsMultiSelect from "../Catalogs/Citizenships/CitizenshipsMultiSelect.vue";
    import EmploymentCategoriesMultiSelect from "../Catalogs/EmploymentCategories/EmploymentCategoriesMultiSelect.vue";
    import DriverLicenseCategoriesMultiSelect from "../Catalogs/DriverLicenseCategories/DriverLicenseCategoriesMultiSelect.vue";

export default {
  name: "LocationVacancies",
  components: { DriverLicenseCategoriesMultiSelect, EmploymentCategoriesMultiSelect, CitizenshipsMultiSelect, VacancySelect, DynamicTables },
  mixins: [
    locationVacancies, catalogs,
    helpers
  ],
  props: {
    isDisabled: { type: Boolean },
    showDetails: { type: Boolean },
    showHeader: { type: Boolean },
    localItems: { type: Array, default: () => null},
    allFieldsRequired: { type: Boolean, default: false }
  },
  data() {
    return {
      locationId: null,
      locationName: '',
      isBusy: false,
      showModalCopying: false,
      items: [],
      deletedItems: [],
      columns: [
        {
          key: 'vacancy',
          label: 'Вакансия',
          type: 'input',
          visible: true,
          isJoint: false
        },
        {
          key: 'workers_count',
          label: 'Количество исполнителей',
          type: 'number',
          placeholder: 'Количество человек в заявке',
          visible: true,
          isJoint: false,
        },
        {
          key: 'duties',
          label: 'Обязанности',
          type: 'input',
          visible: true,
          isJoint: false
        },
        // Требования
        { key: 'sep_requirements', label: 'Требования', isSeparator: true },
        {
          key: 'sex',
          label: 'Пол',
          type: 'input',
          visible: true,
          isJoint: false
        },
        {
          key: 'age_range',
          label: 'Возраст от и до',
          type: 'range',
          visible: true,
          isJoint: true
        },
        {
          key: 'citizenships',
          label: 'Гражданство',
          visible: true,
          isJoint: true
        },
        {
          key: 'criminal_record',
          commentKey: 'criminal_record_comment',
          label: 'Судимость',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: false
        },
        {
          key: 'work_exp',
          label: 'Опыт работы',
          placeholder: 'Опыт, требуемый для выполнения работы',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'physical_work',
          commentKey: 'physical_work_comment',
          label: 'Физический труд',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        {
          key: 'expectations',
          label: 'Ожидания от кандидата',
          type: 'input',
          placeholder: 'Например: порядочность, исполнительность, пунктуальность и т.д.',
          visible: true,
          isJoint: true
        },
        {
          key: 'certificates',
          label: 'Удостоверения / права',
          placeholder: 'Нужны ли удостоверения или права',
          visible: true,
          isJoint: true
        },
        {
          key: 'medical_book',
          commentKey: 'medical_book_comment',
          label: 'Медкнижка',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        // Условия
        { key: 'sep_conditions', label: 'Условия', isSeparator: true },
        {
          key: 'employment',
          label: 'Оформление',
          placeholder: 'Например: договор оказания услуг по СМЗ, выплаты на карту, без оформления',
          visible: true,
          isJoint: true
        },
        {
          key: 'output_format',
          label: 'Формат выхода',
          type: 'multiselect',
          optionsKey: 'outputFormatOptions',
          visible: true,
          isJoint: true
        },
        {
          key: 'employment_categories',
          label: 'Занятость',
          visible: true,
          isJoint: true
        },
        {
          key: 'schedule',
          label: 'График',
          visible: true,
          isJoint: true
        },
        {
          key: 'shift_hours',
          label: 'Часы работы',
          visible: true,
          isJoint: true
        },
        {
          key: 'break_hours',
          label: 'График перерывов',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'work_rate',
          label: 'Выработка (норма)',
          placeholder: 'То, что мы ожидаем от исполнителя как минимум работы',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'salary',
          label: 'Ставка',
          placeholder: 'Общая для всех, кроме бригадиров',
          type: 'number',
          visible: true,
          isJoint: true
        },
        {
          key: 'salary_smz',
          label: 'Ставка СМЗ',
          placeholder: 'Сколько за смену получит исполнитель (количество часов * ставка за час)',
          type: 'number',
          visible: true,
          isJoint: true
        },
        {
          key: 'salary_hand',
          commentKey: 'salary_hand_comment',
          label: 'Карта / на руки',
          placeholder: 'Добавьте комментарий',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        {
          key: 'payment_period',
          label: 'Периодичность выплат',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'probation',
          label: 'Стажировка',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'compensation',
          label: 'Компенсации',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'meals',
          label: 'Питание',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'accommodation',
          label: 'Проживание',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'brigadier_bonus',
          label: 'Бригадирская надбавка',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'uniform',
          label: 'Униформа',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'wardrobe',
          label: 'Раздевалка',
          placeholder: 'Например, закрывается/не закрывается, описание где хранить ценные вещи',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'indoor_conditions',
          label: 'Характеристика помещений',
          placeholder: 'Температурный режим, чистота, условия проветривания и т.д.',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'transport',
          label: 'Как добраться',
          type: 'input',
          visible: true,
          isJoint: true
        },
        {
          key: 'corp_transport',
          commentKey: 'corp_transport_comment',
          label: 'Корпоративный транспорт',
          placeholder: 'Добавить ссылку на точку отправления, либо указать адрес с описанием точки отправки корпоративного транспорта',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        {
          key: 'security_service',
          commentKey: 'security_service_comment',
          label: 'Служба безопасности',
          placeholder: 'Если есть СБ, указать требуемые документы, срок проверки',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        {
          key: 'access_mode',
          commentKey: 'access_mode_comment',
          label: 'Пропускной режим',
          placeholder: 'Требуемые документы, например, паспорт',
          type: 'checkbox-input',
          visible: true,
          isJoint: true
        },
        {
          key: 'prohibited',
          label: 'Ограничения на объекте',
          placeholder: 'Например, использование телефона, украшений',
          type: 'input',
          visible: true,
          isJoint: true
        },
      ],
      jointFields: [],
      outputFormatOptions: [
        { value: 'group', text: 'Групповой' },
        { value: 'single', text: 'По одному' }
      ],
      employmentTypesOptions: [
        { value: 1, text: 'СМЗ' },
        { value: 2, text: 'ГПХ' },
        { value: 3, text: 'ФЛ' },
        { value: 4, text: 'ИП' },
        { value: 5, text: 'В штате' },
      ],
      shiftOptions: [
        { value: 'day', text: 'День' },
        { value: 'night', text: 'Ночь' }
      ],
      citizenshipsCatalog: [],
      employmentCategoriesCatalog: [],
      driverLicenseCategoriesCatalog: []
    };
  },
  async created() {
    await this.getCatalogs();
  },
  computed: {
    renderedColumns() {
      const activeCols = this.columns
        .filter(c => c.visible)
        .map(col => ({  ...col, row_title: col.label  }));

      const headers = [
        {
          id: 'requirements_header',
          title: 'ТРЕБОВАНИЯ',
          keys: new Set(['sex', 'age_range', 'citizenships', 'criminal_record', 'work_exp', 'physical_work', 'expectations', 'certificates', 'medical_book'])
        },
        {
          id: 'conditions_header',
          title: 'УСЛОВИЯ',
          keys: new Set(['employment', 'employment_categories', 'schedule', 'output_format', 'shift_hours', 'break_hours', 'work_rate', 'salary', 'salary_smz', 'salary_hand', 'payment_period', 'probation', 'compensation', 'meals', 'accommodation', 'brigadier_bonus', 'uniform', 'wardrobe', 'indoor_conditions', 'transport', 'corp_transport', 'security_service', 'access_mode', 'prohibited'])
        }
      ];

      headers.forEach(header => {
        const index = activeCols.findIndex(col => header.keys.has(col.key));

        if (index !== -1) {
          activeCols.splice(index, 0, {
            key: header.id,
            row_title: header.title,
            type: 'header',
            visible: true,
            isJoint: false,
            style: 'bg-secondary text-white'
          });
        }
      })
      return activeCols;
    },
    // transposed rows
    setupColumns() {
      const cols = [{
        key: 'row_title',
        tdClass: (value, key, item) => (item.style || 'bg-info col-title-width') + ' sticky-col-left',
        tdAttr: (value, key, item) => item.type === 'header' ? { colspan: this.items.length + 1 } : {}
      }];

      this.items.forEach((_, index) => {
        cols.push({
          key: String(index),
          tdAttr: (value, key, item) => {
            if (item.type === 'header') return {};

            if (this.isFieldJoint(item.key)) {
              if (index === 0) return { colspan: this.items.length };
            }
            return {};
          },
          tdClass: (value, key, item) => {
            if (item.type === 'header') return 'd-none';

            if (this.isFieldJoint(item.key)) {
              return index === 0 ? 'p-0 py-1 align-middle' : 'd-none';
            }
            return 'p-0 py-1 align-middle';
          }
        });
      });
      return cols;
    },
    vacancyModalTabTitles() {
      return this.items.map((item, index) => item.vacancy_name || `Вакансия ${index + 1}`);
    },
    title() {
      return this.items.length > 1 ? 'Вакансии' : 'Вакансия';
    }
  },
  watch: {
    localItems: {
      handler(newValue) {
        if (newValue) {
          this.items = newValue;
        }
      }, deep: true, immediate: true
    }
  },
  methods: {
    configure(locationId = null, locationName = '', vacancyId = null, forceCreate = false) {
      this.isBusy = true;
      this.locationId = locationId;
      this.locationName = locationName;

      this.items = [];

      if (this.localItems && this.localItems.length > 0) {
        this.items = this.localItems;
        this.isBusy = false;
        return;
      }

      if (vacancyId) {
        this.getVacancy(vacancyId);
      } else if (this.locationId && !forceCreate) {
        this.getVacancies();
      } else {
        this.onAdd();
        this.isBusy = false;
      }
    },
    async getVacancy(vacancyId) {
      const result = await this.getLocationVacancyById(vacancyId);

      if (!result || !result.data) {
        this.isBusy = false;
        return;
      }

      this.items = [result.data];
      this.isBusy = false;
    },
    async getVacancies() {
      const result = await this.getLocationVacancyByLocationId(this.locationId);

      if (!result || !result.data) {
        this.isBusy = false;
        return;
      }

      this.items = result.data.items;
      this.isBusy = false;
    },
    async getCatalogs(newItem = null) {
      this.citizenshipsCatalog = (await this.getCitizenships({})).data.items;
      this.employmentCategoriesCatalog = (await this.getEmploymentCategories({})).data.items;
      this.driverLicenseCategoriesCatalog = (await this.getDriverLicenseCategories({})).data.items;
    },
    updateLocation(newLocationId, newLocationName) {
      this.locationId = newLocationId;

      this.items.forEach(item => {
        item.location_id = newLocationId;
        item.location_name = newLocationName;
      });
    },
    async saveVacancies(location) {
      const requests = this.items.map(async (item, index) => {
        const generatedText = this.generateVacancyText(item);
        const processedText = generatedText
          .replace(/\n+/g, '; ')       // переносы строк
          .replace(/-\s/g, '')         // дефисы с пробелами
          .replace(/:\s*;/g, ':')      // : после заголовков
          .replace(/;\s*;/g, ';')      // дублирующиеся точки с запятой
          .replace(/\s+/g, ' ')        // множественные пробелы в один
          .trim();                     // лишние пробелы по краям

        const vacanciesData = { ...item, text: processedText };
        vacanciesData.location_id = item.location_id || location.id;
        vacanciesData.location_name = item.location_name || location.name;

        let result;

        if (vacanciesData.id > 0) {
          result = await this.putLocationVacancy(vacanciesData).catch(() => null);
        } else {
          result = await this.postLocationVacancy(vacanciesData).catch(() => null);
        }

        if (result && result.data) {
          this.items[index].id = result.data.id;
          return true;
        }
        return false;
      });

      const deleteRequests = this.deletedItems.map(async (item) => {
        const result = await this.deleteLocationVacancy(item).catch(() => null);
        return !(!result || result.error);
      });

      const results = await Promise.all([...requests, ...deleteRequests]);

      if (results.includes(false)) {
        return { error: true };
      }

      this.deletedItems = [];
      return { success: true };
    },
    onAdd() {
      const data = {
        id: null,
        location_id: this.locationId,
        location_name: this.locationName,
        vacancy_id: null,
        vacancy_name: '',
        workers_count: null,
        duties: '',
        // требования
        sex: '',
        age_from: null,
        age_to: null,
        citizenships: [],
        criminal_record: false,
        criminal_record_comment: '',
        work_exp: '',
        expectations: '',
        physical_work: false,
        physical_work_comment: '',
        medical_book: false,
        medical_book_comment: '',
        certificates: '',
        driver_license_categories: [],
        // условия
        employment: '',
        employment_types: [],
        employment_categories: [],
        schedule: '',
        schedule_time_of_day: [],
        night_coefficient: '',
        output_format: [],
        shift_hours: '',
        break_hours: '',
        work_rate: '',
        salary: null,
        salary_smz: null,
        salary_hand: false,
        salary_hand_comment: '',
        payment_period: '',
        probation: '',
        compensation: '',
        meals: '',
        accommodation: '',
        brigadier_bonus: '',
        uniform: '',
        wardrobe: '',
        indoor_conditions: '',
        transport: '',
        corp_transport: false,
        corp_transport_comment: '',
        security_service: false,
        security_service_comment: '',
        access_mode: false,
        access_mode_comment: '',
        prohibited: '',
        text: ''
      };

      this.columns.forEach(col => {
        if (this.isFieldJoint(col.key)) {
          data[col.key] = Array.isArray(this.items[0][col.key]) ? [...this.items[0][col.key]] : this.items[0][col.key];

          if (col.key === 'employment') data.employment_types = [...this.items[0].employment_types];

          if (col.key === 'certificates') data.driver_license_categories = [...this.items[0].driver_license_categories];

          if (col.key === 'schedule') {
            data.schedule_time_of_day = [...this.items[0].schedule_time_of_day];
            data.night_coefficient = this.items[0].night_coefficient;
          }
        }
      });

      this.items.push(data);
    },
    onRemove(col) {
      const index = parseInt(col, 10);
      const deleteItem = this.items[index];

      if (deleteItem.id != null) {
        this.deletedItems.push(deleteItem);
      }

      const vacancyName = deleteItem.vacancy_name || 'Новая вакансия';
      const title = "Удаление вакансии";
      const message = `Вы уверены, что хотите удалить вакансию: "${vacancyName}"?`;
      this.showModalDelete(title, message, () => {
        this.items.splice(index, 1);
      });
    },
    isFieldJoint(key) {
      return this.jointFields.includes(key);
    },
    onToggleJoint(key) {
      if (this.isFieldJoint(key)) {
        const aggregateValue = this.items.length > 0 ? this.items[0][key] : '';
        this.updateAllItems(key, aggregateValue);
      }
    },
    updateAllItems(key, event) {
      this.items.forEach(item => {
        this.$set(item, key, event);
      });
    },
    onSelectVacancy(vacancy, col) {
      const itemData = this.items[col];

      if (!itemData) return;

      if (vacancy != null) {
        this.$set(itemData, 'vacancy_id', vacancy.id);
        this.$set(itemData, 'vacancy_name', vacancy.name);
      } else {
        this.$set(itemData, 'vacancy_id', 0);
        this.$set(itemData, 'vacancy_name', '');
      }
    },
    // text copying
    openModalCopying() {
      this.$refs.modal_vacancy_copying.show();
      this.showModalCopying = true;
    },
    closeModalCopying() {
      this.showModalCopying = false;
    },
    generateVacancyText(item) {
      return this.generateVacancyTextString(item);
    },
    copyToClipboard(index) {
      const text = this.generateVacancyText(this.items[index]);

      if (navigator.clipboard) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.$bvToast.toast(`Текст вакансии скопирован.`, {
            title: 'Успешно',
            variant: 'success',
            autoHideDelay: 2000,
            solid: true
          });
        })
        .catch(() => {
          this.$bvToast.toast(`Не удалось скопировать текст.`, {
            title: 'Ошибка',
            variant: 'danger',
            autoHideDelay: 2000,
            solid: true
          });
        });
      }
    },
    getOptions(optionsKey) {
      return this[optionsKey] || [];
    },
    getMultiSelectText(values, options) {
      if (!values || values.length === 0) return 'Выбрать';

      const selected = options
        .filter(opt => values.includes(opt.value !== undefined ? opt.value : opt.id))
        .map(opt => opt.text !== undefined ? opt.text : opt.name);

      return selected.length ? selected.join(', ') : 'Выбрать';
    },
    getShiftTime(shiftHoursStr, index) {
      if (!shiftHoursStr) return '';

      const parts = shiftHoursStr.split(' - ');
      return parts[index] || '';
    },
    updateShiftTimeJoint(index, newValue) {
      const shiftTime = this.items[0].shift_hours || ' - ';
      let parts = shiftTime.split(' - ');

      if (parts.length !== 2) parts = ['', ''];

      parts[index] = newValue || '';
      let updatedString = parts.join(' - ');

      if (updatedString === ' - ') updatedString = '';

      this.updateAllItems('shift_hours', updatedString);
    },
    updateShiftTimeSeparated(itemIndex, timeIndex, newValue) {
      const shiftTime = this.items[itemIndex].shift_hours || ' - ';
      let parts = shiftTime.split(' - ');

      if (parts.length !== 2) { parts = ['', '']; }

      parts[timeIndex] = newValue || '';
      let updatedString = parts.join(' - ');

      if (updatedString === ' - ') { updatedString = ''; }

      this.$set(this.items[itemIndex], 'shift_hours', updatedString);
    },
  }
};
</script>

<style>
.table-bordered td {
  border: 1px solid #c9cdd1;
}

.no-borders-table td:not(:first-child) {
  border-top: none !important;
  border-bottom: none !important;
}

.row-header {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
}

.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
}
.col-title-width {
  width: 200px !important;
}
.min-w-327 {
  min-width: 327px;
}

.sticky-col-left {
  position: sticky;
  left: 0;
  z-index: 1020 !important;
  border-right: none !important;
  overflow: visible !important;
}

.warning-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #ffc107;
  background-color: #ffc107;
}

.warning-checkbox .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(255, 195, 10, 0.25);
}

#modal-vacancy-copying .modal-body {
  padding: 0;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1050;
  background-color: white;
}

.z-index-dropdown {
  z-index: 1025 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationVacancies.vue